// extracted by mini-css-extract-plugin
module.exports = {"profileIconWrapper":"SearchResultImage_profileIconWrapper__1yaHX","profileIcon":"SearchResultImage_profileIcon__3Ysr9"};